import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {allpayments} from "models/allpayments"; // Importing allpayments model
import {devConfig, gamesCasino, profile, providersCasino} from "config/config"; // Importing configuration settings

/**
 * Class representing the view for table partners products.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var list1 = {
            view: "dbllist",
            id:"dbllist",
            list: {
              height: 0,
              scroll: true
            },
            labelLeft: _("Productos no agregados"), // Left label for unadded products
            labelRight: _("Productos Agregados"), // Right label for added products
            data: [] // Initial data for the list
        };

        // Main form configuration
        return {
            view: "form", id: "f1",
            rows: [
                {
                  view: "forminput",
                  name: "access",
                  body: list1, // Body of the form input
                  labelWidth: 140, // Width of the label
                  labelAlign: "right" // Label alignment
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService("locale")._; // Localization service
        var values=""; // Variable to hold product values
        const id_partner = this.getParam("partner", true); // Get partner ID from parameters
        var string1 = ""; // Query string for filtering
        var string2 = ""; // Query string for massive product operations
        var vthis = this; // Reference to the current instance

        // Event listener for filtering partner products
        this.on(this.app, "partnerProducts:filter", filterData => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ""; // Reset query string

            // Construct the query string based on filter data
            for (var i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                    if (object[i][0] == "Datepicker") {
                        var date = object[i][1].split(" - "); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if ((typeof object[i][1] === "object")) {
                        var object2 = Object.entries(object[i][1]); // Handle object filters
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") {
                                    var d = new Date(object2[j][1]); // Convert start date to Date object
                                    var dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === "end") {
                                        var d = new Date(object2[j][1]); // Convert end date to Date object
                                        var dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clear the double list and set new values based on the query
            $$("dbllist").$$("left").clearAll();
            $$("dbllist").setValue([]);
            webix.ajax().get(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProducts", string1, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message("Error! "); // Error handling
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse response data
                    if(!data.HasError){
                        $$("dbllist").$$("left").clearAll();
                        $$("dbllist").setValue([]);
                        $$("dbllist").parse(data.Data.ExcludedProductsList); // Populate excluded products
                        $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                        $$("dbllist").hide();
                        let countLeft = $$("dbllist").$$("left").data.serialize();
                        let countRight = $$("dbllist").$$("right").data.serialize();
                        const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                        labelLeft.define("label", _("Productos no agregados") + " (" + countLeft.length + ")" );
                        labelRight.define("label", _("Productos Agregados") + " (" + countRight.length + ")" );
                        labelLeft.refresh();
                        labelRight.refresh();
                        values=data.Data.IncludedProductsList; // Update values
                        string2 = ""; // Reset string2
                    } else {
                        webix.message("Error! "); // Error handling
                    }
                }
            });
        });

        // Event listener for massive product operations
        this.on(this.app, "partnerProducts:productMassive", filterData => {
            string2 = filterData; // Store filter data for massive operation
            webix.ajax().headers({
                "Content-type": "application/json" // Set content type for the request
            }).post(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProductsMassive", filterData, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message("Error! "); // Error handling
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(text); // Parse response data
                    if (!data.HasError) {
                        webix.message("Productos Masivos Agregados"); // Success message
                        $$("dbllist").$$("left").clearAll();
                        $$("dbllist").setValue([]);
                        $$("dbllist").parse(data.Data.ExcludedProductsList); // Populate excluded products
                        $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                        let countLeft = $$("dbllist").$$("left").data.serialize();
                        let countRight = $$("dbllist").$$("right").data.serialize();
                        const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                        labelLeft.define("label", _("Productos no agregados") + " (" + countLeft.length + ")" );
                        labelRight.define("label", _("Productos Agregados") + " (" + countRight.length + ")" );
                        labelLeft.refresh();
                        labelRight.refresh();
                        values = data.Data.IncludedProductsList; // Update values
                        string1 = ""; // Reset string1
                    } else {
                        // Handle error case
                    }
                }
            });
        });

        // Event listener for changes in the double list
        $$('dbllist').attachEvent("onChange", function (id, e, node) {
            var array1= values.split(","); // Split current values into an array
            var array2= $$('dbllist').getValue().split(","); // Split selected values into an array
            var arrayAgregados = []; // Array for added products
            var arrayEliminados = []; // Array for removed products

            // Determine added products
            array2.forEach(function (obj) {
                var found = array1.find(function(element) {
                    return element == obj; // Check if the product was already included
                });
                if(found == undefined){
                    arrayAgregados.push(obj); // Add to added products if not found
                }
            });

            // Determine removed products
            array1.forEach(function (obj) {
                var found = array2.find(function(element) {
                    return element == obj; // Check if the product is still selected
                });
                if(found == undefined){
                    arrayEliminados.push(obj); // Add to removed products if not found
                }
            });

            values = $$('dbllist').getValue(); // Update values with current selection

            // Create a confirmation window for the user
            webix.ui({
                view: "window",
                head: {
                    view: "toolbar",
                    cols: [
                        {view: "label", label: _("Desea realizar movimiento?")} // Confirmation message
                    ]
                },
                position: "center",
                modal: true,
                body: {
                    view: "form", id: "form", elements: [
                        {
                            view: "text",
                            label: _("Observación"), // Label for observation input
                            name: "Note",
                            required: true, // Make this field required
                            labelWidth: 100,
                            invalidMessage: _("Mínimo 10 caracteres") // Validation message
                        },
                        {
                            cols: [
                                {
                                    view: "button", value: _("Cancelar"), click: function () {
                                        this.getTopParentView().hide(); // Hide the window on cancel
                                        $$('form').setValues($$('form').getCleanValues()); // Reset form values
                                        if (string1.length == 0 && string2.CSV != undefined || string2.CSV != undefined) {
                                            webix.ajax().headers({
                                                "Content-type": "application/json" // Set content type for the request
                                            }).post(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProductsMassive", string2, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message("Error! "); // Error handling
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var data = JSON.parse(text); // Parse response data
                                                    if (!data.HasError) {
                                                        $$("dbllist").$$("left").clearAll();
                                                        $$("dbllist").setValue([]);
                                                        $$("dbllist").parse(data.Data.ExcludedProductsList); // Populate excluded products
                                                        $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                                                        let countLeft = $$("dbllist").$$("left").data.serialize();
                                                        let countRight = $$("dbllist").$$("right").data.serialize();
                                                        const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                                                        labelLeft.define("label", _("Productos no agregados") + " (" + countLeft.length + ")" );
                                                        labelRight.define("label", _("Productos Agregados") + " (" + countRight.length + ")" );
                                                        labelLeft.refresh();
                                                        labelRight.refresh();
                                                        values = data.Data.IncludedProductsList; // Update values
                                                    } else {
                                                        // Handle error case
                                                    }
                                                }
                                            });
                                        } else if (string1.length !== 0) {
                                            webix.ajax().get(devConfig.geturlApi() + "PartnersProducts/GetGroupPartnersProducts", string1, {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message("Error! "); // Error handling
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var data = JSON.parse(text); // Parse response data
                                                    if (!data.HasError) {
                                                        $$("dbllist").$$("left").clearAll();
                                                        $$("dbllist").setValue([]);
                                                        $$("dbllist").parse(data.Data.ExcludedProductsList); // Populate excluded products
                                                        $$("dbllist").setValue(data.Data.IncludedProductsList); // Set included products
                                                        let countLeft = $$("dbllist").$$("left").data.serialize();
                                                        let countRight = $$("dbllist").$$("right").data.serialize();
                                                        const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                                                        labelLeft.define("label", _("Productos no agregados") + " (" + countLeft.length + ")" );
                                                        labelRight.define("label", _("Productos Agregados") + " (" + countRight.length + ")" );
                                                        labelLeft.refresh();
                                                        labelRight.refresh();
                                                        values = data.Data.IncludedProductsList; // Update values
                                                    } else {
                                                        webix.message("Error! "); // Error handling
                                                    }
                                                }
                                            });
                                        }
                                    }
                                },
                                {
                                    view: "button",
                                    type: "form",
                                    value: _("Guardar"), // Save button
                                    click: function ($e) {
                                        var valuesForm = $$("form").getValues(); // Get form values
                                        if ($$("form").validate()) { // Validate form
                                            var vthis = this; // Reference to the current instance
                                            vthis.getTopParentView().hide(); // Hide the window
                                            webix.ajax().headers({
                                                "Content-type": "application/json" // Set content type for the request
                                            }).post(devConfig.geturlApi() + "PartnersProducts/SaveGroupPartnersProducts", '{"Partner":"' + id_partner + '","IncludedProductsList":"' + arrayAgregados + '","ExcludedProductsList":"' + arrayEliminados + '","Note":"' + valuesForm.Note + '","CountrySelect":"' + $$("CountrySelect").getValue() + '"}', {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_("Error! ")); // Error handling
                                                    vthis.getTopParentView().hide(); // Hide the window
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var data = JSON.parse(text); // Parse response data
                                                    if (!data.HasError) {
                                                        webix.message(_("Producto Partner Editado")); // Success message
                                                        let countLeft = $$("dbllist").$$("left").data.serialize();
                                                        let countRight = $$("dbllist").$$("right").data.serialize();
                                                        const [labelLeft, labelRight] = $$("dbllist").queryView({view:"label"}, "all");
                                                        labelLeft.define("label", _("Productos no agregados") + " (" + countLeft.length + ")" );
                                                        labelRight.define("label", _("Productos Agregados") + " (" + countRight.length + ")" );
                                                        labelLeft.refresh();
                                                        labelRight.refresh();
                                                    } else {
                                                        webix.message(_("Error! ")); // Error handling
                                                    }
                                                    vthis.getTopParentView().hide(); // Hide the window
                                                }
                                            });
                                        }
                                    },
                                }
                            ]
                        }
                    ], elementsConfig: {
                        on: {
                            onChange: function () {
                                $$("form").validate(); // Validate form on change
                            }
                        }
                    },
                    rules: {
                        Note: function (value) {
                            return value.length >= 10; // Custom validation rule for observation
                        }
                    }
                }
            }).show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
